export const APP_STORE_LINKS = {
  GOOGLE_PLAY: 'https://play.google.com/store/apps/details?id=com.sahayy',
  APPLE_APP_STORE: 'https://apps.apple.com/in/app/sahayy/id6753900770',
};

export const APP_INFO = {
  BUNDLE_ID: 'com.sahayy',
  IOS_APP_ID: '6753900770',
};
